export default __webpack_public_path__ + "media/3f7b83bb2c314e4d2ebe0937fad10704adee5ff8fb5c6b5c3d1d43ba7283fc66.svg";